<template>
  <v-container fluid>

    <v-row justify="center">
      <v-col cols="12">
        <h1>会社登録</h1>
      </v-col>
    </v-row>

    <v-row justify="center" v-if="view.errors.length > 0">
      <v-col cols="12">
        <mp-error :errors="view.errors" message-key="message.admin.mst.company.error."/>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>グループ分類<span class="red--text">※</span></mp-label>
      </v-col>
      <v-col cols="8" outlined tile>
        <mp-input-box>
          <v-select
            v-model="form.groupSmallId"
            :items="view.groupList"
            label="グループ分類を選択してください"
            item-text="text"
            item-value="value"
            hide-details
            solo
            dense
            color="green"
            item-color="green"
          ></v-select>
        </mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>会社名<span class="red--text">※</span></mp-label>
      </v-col>
      <v-col cols="8" outlined tile>
        <mp-input-box>
          <v-text-field
            v-model="form.companyName"
            hide-details
            placeholder="会社名を入力してください"
            solo
            dense
            maxlength="100"
          ></v-text-field>
        </mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>会社名カナ</mp-label>
      </v-col>
      <v-col cols="8" outlined tile>
        <mp-input-box>
          <v-text-field
            v-model="form.companyNameKana"
            hide-details
            placeholder="会社名カナを入力してください"
            solo
            dense
            maxlength="100"
          ></v-text-field>
        </mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>表示順</mp-label>
      </v-col>
      <v-col cols="8" outlined tile>
        <mp-input-box>
          <v-text-field
            v-model="form.displayOrder"
            hide-details
            placeholder="表示順を入力してください"
            solo
            dense
            maxlength="4"
          ></v-text-field>
        </mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12" class="pt-0">
        <div>
          ※表示順はクラブの場合のみ設定してください。
        </div>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col
        class="text-center"
        cols="6"
        md="3"
      >
        <mp-button wide @click="goList">戻る</mp-button>
      </v-col>
      <v-col
        class="text-center"
        cols="6"
        md="3"
      >
        <mp-button wide @click="goRegister">登録する</mp-button>
        <mp-dialog regist :show="dialog.registComplete" @clickOk="goList" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Common, AdminMstCompany } from '@/api'
import MpLabel from '@/components/item/MpLabel'
import MpInputBox from '@/components/item/MpInputBox'
import MpError from '@/components/item/MpError'
import MpButton from '@/components/item/MpButton'
import MpDialog from '@/components/item/MpDialog'

export default {
  name: 'AdminMstCompanyAdd',
  components: {
    MpLabel,
    MpInputBox,
    MpError,
    MpButton,
    MpDialog
  },
  data: () => ({
    view: {
      errors: [],
      groupList: []
    },
    form: {
      companyId: null,
      groupSmallId: null,
      companyName: '',
      companyNameKana: '',
      displayOrder: null
    },
    dialog: {
      registComplete: false
    }
  }),
  methods: {
    goList () {
      this.$router.push({ path: '/admin/mst/company/list' })
    },
    async goRegister () {
      await AdminMstCompany.register(this.form)
        .then(() => { this.dialog.registComplete = true })
        .catch(error => { this.view.errors = error.messages })
    }
  },
  created: async function () {
    this.view.groupList = (await Common.groupList())
      .filter(groupLarge => groupLarge.companyInsNoFlg === '0')
      .flatMap(groupLarge => groupLarge.groupSmallList
        .map(groupSmall => ({
          text: groupLarge.groupLargeName.ja + '＞' + groupSmall.groupSmallName.ja,
          value: groupSmall.groupSmallId
        })))
  }
}
</script>
